import { createContext, ReactNode, useCallback, useEffect, useMemo, useState } from 'react';
import { Breakpoint, breakpoints } from './breakpoints';

// Create the context and extract the provider
export const BreakpointContext = createContext<Breakpoint>('md');
const { Provider } = BreakpointContext;

// Create a provider component and add the logic to work out the current breakpoint
export function BreakpointProvider({ children }: { children: ReactNode }) {
  const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth);

  //   Create function to handle finding and setting the correct breakpoint
  const getBreakpoint = useCallback(() => {
    // Find out the width of the window
    const currentWidth = windowWidth;
    // Convert the breakpoints to an array with key and value
    const breakpointsAsArray = Object.entries(breakpoints);
    //   Map this to the correct breakpoint
    const overBreakpointIndex = breakpointsAsArray.findIndex((bp) => bp[1] > currentWidth);

    //   Find the one below the breakpoint

    const currentBreakpoint =
      breakpointsAsArray[(overBreakpointIndex !== -1 ? overBreakpointIndex : breakpointsAsArray.length) - 1][0];

    // Guard clause for no breakpoint
    if (!currentBreakpoint) return 'sm'; // check this
    return currentBreakpoint as Breakpoint;
  }, [windowWidth]);

  const breakpoint = useMemo<Breakpoint>(() => getBreakpoint(), [windowWidth, getBreakpoint]);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window?.innerWidth);
    };
    // Set up listeners for size changes and run again
    window.addEventListener('resize', handleResize);

    // Remove listeners on unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return <Provider value={breakpoint}>{children}</Provider>;
}
